import type { APIClientConfig } from '../config';
import { initializeAPIClientConfig } from '../config';

interface APIClientProps extends APIClientConfig {}

export function initializeAPIClient(props: APIClientProps = {}, options: { validate?: boolean } = {}) {
  initializeAPIClientConfig(props, options);
}
